module.exports = function() {
  return new Worker(__webpack_public_path__ + "a8918d505396415ecb05.worker.js");
};